import React from 'react'
import { IonTextarea, IonItem, IonLabel } from '@ionic/react';


const TextArea = (props) => {
    return (
        <IonItem lines="none">
            <IonLabel className="input-label" position="stacked">{props.name}</IonLabel>
            <IonTextarea className='input-field' {...props} clearInput></IonTextarea>
        </IonItem>
    )
}

export default TextArea
